// extracted by mini-css-extract-plugin
module.exports = {"logos__carousel":"styles_logos__carousel__BN1FL","logos__footer":"styles_logos__footer__6JnJv","logos__link":"styles_logos__link__9cGXO"};